import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { ChannelConfigType } from 'src/lib/types/channels'
import { DiscountFormStateType } from 'src/lib/types/discounts'
import FloCheckbox from 'src/components/common/form-elements/FloCheckbox'
import { useLocale } from 'src/lib/hooks/useLocal'
import { getDefaultChannels } from 'src/lib/utils/helpers'
import produce from 'immer'
import { Info } from 'react-feather'

interface DiscountsChannelsFormProps {
  discountFormState: DiscountFormStateType | undefined
  setFormState: Dispatch<SetStateAction<DiscountFormStateType | undefined>>
}

const DiscountsChannelsForm: React.FC<DiscountsChannelsFormProps> = ({ discountFormState, setFormState }) => {
  const { t } = useLocale()

  const getChannelDetails = async () => {
    const defaultChannelConfig = await getDefaultChannels()
    if (discountFormState !== undefined)
      setFormState(
        produce((draft: any) => {
          draft.channels = defaultChannelConfig
        })
      )
  }

  useEffect(() => {
    if (!discountFormState?.channels || discountFormState?.channels?.length < 1) {
      getChannelDetails()
      return
    }
    const enabledChannelCount = discountFormState?.channels?.filter(
      (channel: ChannelConfigType) => channel?.enabled === true
    ).length
    if (enabledChannelCount === 1) {
      const enabledIndex = discountFormState?.channels?.findIndex(
        (channel: ChannelConfigType) => channel?.enabled === true
      )
      setFormState(
        produce((draft: any) => {
          draft.channels[enabledIndex].editable = false
        })
      )
    }
    if (enabledChannelCount === 2) {
      setFormState(
        produce((draft: any) => {
          discountFormState?.channels?.forEach(
            (channel: ChannelConfigType, index: number) => (draft.channels[index].editable = true)
          )
        })
      )
    }
  }, [discountFormState?.channels])

  const handleChange = (id: string, checked: boolean) => {
    if (discountFormState?.channels) {
      const channelIndex = discountFormState.channels.findIndex((obj: any) => obj.id === id)
      const channelsDump = [...discountFormState?.channels]
      const modifiedChannel = { ...channelsDump[channelIndex] }
      modifiedChannel.enabled = checked
      channelsDump[channelIndex] = modifiedChannel
      setFormState(
        produce((draft: any) => {
          draft.channels = channelsDump
        })
      )
    }
  }

  return (
    <div className='flex flex-col p-3 gap-3 bg-white border rounded border-gray-light'>
      <h2 className='text-carbon text-base font-medium'>{t('active_channels')}</h2>
      <div className='flex flex-col gap-3'>
        {discountFormState?.channels &&
          discountFormState?.channels?.filter((channel: any) => channel?.enabled === true)?.length < 2 && (
            <div className='inline-flex gap-2 text-sm border rounded border-[#C7981F66] bg-[#C7981F1A] w-full p-3 items-center'>
              <div className='w-4'>
                <Info className='text-[#C7981F] w-4 h-4' />
              </div>
              <p className='text-carbon'>{t('cant_disable_all_channels_discount')}</p>
            </div>
          )}
        <ul>
          {discountFormState?.channels?.map(channel => {
            const isEnabled = discountFormState?.channels?.find((obj: any) => obj.id === channel.id)?.enabled ?? false
            return (
              <li key={`${channel.id}`}>
                <FloCheckbox
                  value={isEnabled}
                  setValue={(checked: boolean) => handleChange(channel.id, checked)}
                  label={channel.name === 'Web' ? 'Website' : channel.name}
                  color='#4D4D4D'
                  isDisabled={!channel?.editable}
                />
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}

export default DiscountsChannelsForm
